import React, { useEffect, useRef, useState } from 'react'
import { ActivityIndicator, StyleSheet } from 'react-native'
import SessionManager from 'APP/NativeModules/SessionManager'

import { Colors } from 'APP/Themes'
import { VideoContainer } from './Container'

interface SubscriberViewProps {
  isMuted?: boolean
  isVideoOff?: boolean
  streamId?: string
}

const SubscriberView: React.FC<SubscriberViewProps> = ({ streamId }) => {
  const videoWrapper = useRef<HTMLDivElement>(null)

  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (videoWrapper.current && streamId) {
      SessionManager.subscribe(streamId).then((videoElement: HTMLVideoElement) => {
        videoElement.style.width = '100%'
        videoElement.style.height = '100%'
        videoElement.style.objectFit = 'cover'

        videoElement.addEventListener('loadeddata', () => setIsReady(true))

        const wrapper = videoWrapper.current
        if (typeof wrapper?.appendChild === 'function') {
          wrapper.appendChild(videoElement)
        }
      })
    }
    return () => {
      SessionManager.unsubscribe()
    }
  }, [streamId])

  return (
    <>
      <VideoContainer
        testID="subscriber-video"
        ref={videoWrapper as never}
        isReady={isReady}
      ></VideoContainer>
      {!isReady && (
        <ActivityIndicator
          testID="subscriber-loading"
          color={Colors.videoBorder}
          animating
          size="large"
          style={StyleSheet.absoluteFill}
        />
      )}
    </>
  )
}

export default SubscriberView
